// extracted by mini-css-extract-plugin
export default {"floatingBubble":"floatingBubble_floatingBubble__aqoKw"};